import React from 'react';
import { BaseCell } from '../../../../../../../components';
import { RuleDataItem } from '../../lib/service';

const recurrenceMap = new Map([
  ['DAILY', 'Diário'],
  ['WEEKLY', 'Semanal'],
  ['MONTHLY', 'Mensal'],
]);

const RulesPageTableRecurrenceCell = ({ recurrence }: RuleDataItem) => {
  if (!recurrence?.recurrenceType) return <BaseCell>--</BaseCell>;
  return <BaseCell>{recurrenceMap.get(recurrence.recurrenceType)}</BaseCell>;
};

export default RulesPageTableRecurrenceCell;
